<div class="login-container row">
  <div class="col-lg-7 col-md-12 col-12 left-section">
    <div class="logo-section text-center col-xs-hidden">
      <h2 class="logo-title">Biometric Authentication System</h2>
      <p class="my-lg-4 my-4 logo-desc">
        Platform to enroll each associate/ workforce entering organization
        through manpower agencies to verify their eligibility.
      </p>
      <img src="assets/images/Frame.svg" class="img-responsive" alt="BAS" />
    </div>
  </div>
  <div class="col-lg-5 col-md-12 col-12 py-0 login-wrapper">
    <div class="login-section">
      <mat-card class="login-card">
        <form class="login-form" [formGroup]="setpasswordForm" (submit)="setPasswordSubmit()" autocomplete="off">
          <div class="form-group">
            <label class="form-title" for="signin">Set New Password</label>
            <p class="login-info">
              Set the new password for your registered number <br /><b>{{
              userMobile
            }}</b>
          </p>
        </div>
        <div class="form-group">
          <div class="icon-field">
            <input matInput class="form-control password-field" formControlName="password"
              [type]="showPassword ? 'text' : 'password'" placeholder="Enter Password" autocomplete="off" value=""
              minlength="10" maxlength="20" (keyup)="watchChange()" required />
              <mat-icon matSuffix (click)="toggleInputType()">
                @if (!showPassword) {
                  <img class="eye-icon" src="../../../assets/images/show-password-icon.svg" />
                }
                @if (showPassword) {
                  <img class="eye-icon" src="../../../assets/images/hide-password-icon.svg" />
                }
              </mat-icon>
            </div>
            <div class="error-section">
              @if (
                setpasswordForm.controls.password.errors &&
                (setpasswordForm.controls.password.touched ||
                setpasswordForm.controls.password.dirty)
                ) {
                <p class="err-msg" [hidden]="
                    !setpasswordForm.get('password').hasError('required')
                  ">
                  Password is required
                </p>
                <p class="err-msg" [hidden]="
                    !setpasswordForm.get('password').hasError('pattern')
                  ">
                  Must contain atleast 1 uppercase, 1 lowercase<br />,1 number
                  and 1 special character
                </p>
                <p class="err-msg" [hidden]="
                    !setpasswordForm.get('password').hasError('minlength')
                  ">
                  Must include atleast 10 characters
                </p>
                <p class="err-msg" [hidden]="!setpasswordForm.get('password').hasError('weak')">
                  Password is Weak
                </p>
              }
            </div>
          </div>

          <div class="form-group">
            <div class="icon-field">
              <input matInput class="form-control password-field" formControlName="cpassword"
                [type]="showCPassword ? 'text' : 'password'" placeholder="Confirm Password" autocomplete="off" value=""
                minlength="10" maxlength="20" required />
                <mat-icon matSuffix (click)="toggleInput()">
                  @if (!showCPassword) {
                    <img class="eye-icon" src="../../../assets/images/show-password-icon.svg" />
                  }
                  @if (showCPassword) {
                    <img class="eye-icon" src="../../../assets/images/hide-password-icon.svg" />
                  }
                </mat-icon>
              </div>
              <div class="error-section">
                @if (
                  setpasswordForm.controls.cpassword.errors &&
                  (setpasswordForm.controls.cpassword.touched ||
                  setpasswordForm.controls.cpassword.dirty)
                  ) {
                <p class="err-msg" [hidden]="
                    !setpasswordForm.get('cpassword').hasError('required')
                  ">
                    Password is required
                  </p>
                <p class="err-msg" [hidden]="
                    !setpasswordForm.get('cpassword').hasError('minlength')
                  ">
                    Must include atleast 10 characters
                  </p>
                <p class="err-msg" [hidden]="
                    !setpasswordForm.get('cpassword').hasError('mustMatch')
                  ">
                    Passwords must match
                  </p>
                }
              </div>
            </div>
            <div>
              @if (strengthbar) {
                <bas-password-strenth-checker [passwordToCheck]="setpasswordForm.value.password"
                  (passwordStrength)="onPasswordStrengthChanged($event)">
                </bas-password-strenth-checker>
              }
            </div>
            <div class="form-actions text-center">
              <button type="submit" class="login-submit" [ngClass]="setpasswordForm.valid ? 'hoverEffect' : ''"
                name="login" [disabled]="setpasswordForm.invalid || strength">
                <span>Set Password</span>
              </button>
            </div>
          </form>
        </mat-card>
      </div>
    </div>
  </div>